import { HttpClient } from "../common/http-client";
import { Environment } from "../environment/app-settings";
import { CodeSubmitAgainResponse } from "../models/responses/code-submit-again.response";

export class SmsCodeService{
    private readonly _client : HttpClient
    private readonly _url = "smsCode";
    constructor(){
        this._client = new HttpClient(Environment.apiUrl);
    }
    
    public async submitAgainSmsCode(): Promise<CodeSubmitAgainResponse>{
        const url = `${this._url}`;
        const response = await this._client.get<CodeSubmitAgainResponse>(url, true);
        return response.data;
    }
}